module.exports = __webpack_public_path__ + "media/img/avatar-f06ce2a8242d75b191579a0b203a0036.jpg";